var video_viewer_default = {
  "video_player": "qKpxB",
  "videoOverlay": "rmrEp",
  "video_container": "QENNY"
};
export {
  video_viewer_default as default
};
//# sourceMappingURL=video-viewer-scss.js.map
